import { useLocale } from "../i18n";
import "./field-requirement.css";

/** Mirrors native/ARIA required state without changing the field's accessible name. */
export function FieldRequirement({ required }: { required: boolean | undefined }) {
  const { w } = useLocale();
  return <span className="field-requirement" data-required={!!required} aria-hidden="true"
    title={required ? w("إلزامي", "Required") : undefined}
    data-label={required ? "*" : w("اختياري", "Optional")} />;
}
